import { all, call } from 'redux-saga/effects';

import watchDataElement from './dataElements';
import watchSocialSaga from './social';
import watchDigitainSaga from './fetchDigitainData';
import { watchDataElementsSaga } from './pragmaticLiveWS';

export function* rootStoreSaga() {
  yield all([call(watchDataElement), call(watchSocialSaga), call(watchDigitainSaga), call(watchDataElementsSaga)]);
}
